import { render } from "./WidgetAlerts.vue?vue&type=template&id=ecdbb672"
import script from "./WidgetAlerts.vue?vue&type=script&lang=js"
export * from "./WidgetAlerts.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__